import { useEffect } from 'react';
import { trackAbTestEvent } from 'dibs-tracking';
import { getAbTestTrackingData } from 'dibs-buyer-layout/exports/clientABTestHelpers';

export const useClickabilityTracking = (): void => {
    useEffect(() => {
        const trackingData = getAbTestTrackingData(document.cookie, 'TopYMAL_Clickability');
        trackAbTestEvent(trackingData, 'pdp_pageview');
    }, []);
};
